const CompareTable = () => ({
  bikes: [],
  selectedBikeIds: [],
  get selectedBikes() {
    return this.selectedBikeIds.map(id => this.bikes.find(b => b.id == id));
  },
  init() {
    const script = document.querySelector("#compare-table-data");
    const data = JSON.parse(script.innerText);

    this.bikes = data ?? [];
    this.selectedBikeIds = [data[0].id, data[1].id, data[2].id];
  }
});

export default CompareTable;
